import graphqlRequest from "../storyGuideRequest";
import GET_STORY from "./getStoryGraphql";

export async function getStory(skillIds, activityType) {
  const filter = activityType
    ? {
        activityType
      }
    : {};

  let inputs = {
    skillIds,
    filter,
  };

  return await graphqlRequest(GET_STORY, inputs);
}
